export default {
  methods: {
    $success(str, duration = 3000) {
      this.$message({
        message: str,
        type: "success",
        duration
      });
    },
    $warning(str, duration = 3000) {
      this.$message({
        message: str,
        type: "warning",
        duration
      });
    },
    $error(str, duration = 3000) {
      this.$message({
        message: str,
        type: "error",
        duration
      });
    },
    $load(text, bg = "black") {
      return this.$loading({
        lock: true,
        text: text,
        spinner: "el-icon-loading",
        background: bg === "black" ? "hsla(0,0%,100%,.9)" : "rgba(0, 0, 0, 0.7)"
      });
    },
    $rgb() {
      let r = () => Math.floor(Math.random() * 256); // rgb颜色随机
      return "rgb(" + r() + "," + r() + "," + r() + ")";
    },
    $log(message = "我是打印日志") {
      const styles = [
        `color: #fff`,
        `background: ${this.$rgb()}`,
        "font-size: 12px",
        `border: 1px solid #ccc`,
        "padding: 5px"
      ].join(";");
      let myObj = {};
      Error.captureStackTrace(myObj);
      let str = String(myObj.stack);
      let arr = str.split("\n"); // 以换行为分割
      window.Error.stack = arr;
      console.log(
        "%c%s%c%s",
        styles,
        message,
        styles,
        `查看 window.Error.stack`
      );
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/message.js